<div class="flex-space-evenly flex-col" >
  @if (name || tag || type) {
    <table class="header-table">
      <tr>
        <td class="label">Name: </td>
        <td>
          <h4 class="item-name">{{ name }}</h4>
        </td>
        @if (disabledSource) {
          <td class="disabled-label">
            <strong
              [attr.data-testid]="'disabled-text'"
              class="disabled-source"
              >
              {{ disabledSource }}
            </strong>
          </td>
        }
      </tr>
      @if (tag) {
        <tr>
          <td class="label">Tag: </td>
          <td>
            <h4 class="header-info" [attr.title]="tag"> {{ tag }}</h4>
          </td>
        </tr>
      }
      @if (type) {
        <tr>
          <td class="label">Type: </td>
          <td>
            <h4 class="header-info" [attr.type]="type"> {{ type }}</h4>
          </td>
          <td>
            @if ((selectedScreen$ | async).route === 'items' || (selectedScreen$ | async).route === 'item-groupings') {
              <emm-locales-select
                class="locale-selector"
              ></emm-locales-select>
            }
          </td>
        </tr>
      }
      @if (description) {
        <tr>
          <td>
            <span class="label">Description: </span>
          </td>
          <td>
            <span class="description-value">{{ description }}</span>
          </td>
        </tr>
      }
    </table>
  }
</div>
